export const GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_ABORTED =
  'GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_ABORTED';
export const GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_REQUESTED =
  'GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_REQUESTED';
export const GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_COMPLETED =
  'GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_COMPLETED';
export const GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_FAILED =
  'GET_CLIENTDOCUMENTREADS_FOR_ACCOUNT_FAILED';
